import textStyles from '../TextMenu.module.css'
import {Helmet} from "react-helmet";
import React from "react";
export default function MenuWarranty(){
    return(
        <div className={textStyles.mainCont}>
            <Helmet>
                <title>sim-unlim : Гарантии</title>
                <link rel="canonical" href="https://sim-unlim.com/warranty" />
                <meta name="description" content="Гарантии тариф не изменят оператор sim-unlim.com" />
            </Helmet>
            <div className={textStyles.blCont}>
                <div className={textStyles.head}><p >Гарантии на товар</p></div>
                <p>
                    <span className={textStyles.bold}>Гарантии возврата : </span>
                    В случае невозможности доставки товара, доставки некачественного или бракованного товара, продавец возвращает стоимость оплаченного заказа, включая стоимость доставки покупателю. Оформить заявку на возврат можно в личном кабинете. Максимальный срок возврата составляет 10 рабочих дней с момента оформления заявки на возврат. Возврат осуществляется исключительно на банковскую карту, с которой был осуществлен платеж. Денежные средства, внесенные на SIM-карту оператора, возврату не подлежат, т.к. эти денежные средства зачисляются в пользу оператора, а не продавца.
                </p>
            </div>
            <div className={textStyles.blCont}>
                <p>
                    <span className={textStyles.bold}>Гарантии на тариф : </span>
                    Операторы мобильной связи имеют право в одностороннем порядке пересмотра цен на услуги связи не чаще, чем один раз в год. В случае изменения тарифного плана, оператор заблаговременно уведомляет клиента об изменении цен. По вопросам изменения тарифного палана клиенту следует обратиться к оператору связи или к персональному менеджеру нашей компании через личный кабинет.
                </p>
            </div>

        </div>

    )
}